import React from 'react';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';

interface IProps {
  operations: Operation[],
  operationsSelected: string[]
}

// Runtime dependency
const DmbPlugin: React.FC<IProps> = React.lazy(() => importFromS3('dmb'));

export const DmbPluginContainer: React.FC<IProps> = ({ operations, operationsSelected }: IProps) => (
  <DmbPlugin
    operations={operations}
    operationsSelected={operationsSelected}
  />
);
